import React from "react";
import "../../Components/Menu/Menu.css";

export default function Information() {
  return (
    <div>
      <h4 className="sub-title">Opplysninger om behandlingsansvarlig </h4>
      <p className="content">
        <p>Navn: Gjensidige Mobility Group AS</p>
        <p> Adresse: Postboks 6004 Torgården, 7434 TRONDHEIM </p>
        <p>
          E-post: {""}
          <a className="mail-lab" href="mailto:hei@bilista.no">
            hei@bilista.no
          </a>
        </p>
      </p>
    </div>
  );
}
